import { CheckIcon, MessageCircleIcon, RotateCcwIcon } from 'lucide-react';
import { clinic } from '../data/clinic';
import { BrandMark } from './BrandMark';
interface ThankYouScreenProps {
  onRestart: () => void;
}
export function ThankYouScreen({
  onRestart
}: ThankYouScreenProps) {
  return <section className="flex min-h-screen w-full items-center justify-center bg-olive-800 px-6 py-20 sm:px-10" data-id="element-75" data-mp="wrkeerlu2nxa">
      <div className="w-full max-w-2xl text-center" data-id="element-76" data-mp="1khernaa2eei2">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-gold-400 text-gold-400" aria-hidden="true" data-id="element-77" data-mp="1khwu4onbloyf">
          <CheckIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-78" data-mp="1bo1olfiadwi9" />
        </span>

        <h1 className="mt-10 font-display text-5xl leading-tight text-cream-50 sm:text-6xl" data-id="element-79" data-mp="1fpwlm7t6pnq8">
          {clinic.thankYouTitle}
        </h1>

        <p className="mx-auto mt-6 max-w-xl font-sans text-base leading-relaxed text-cream-100/75" data-id="element-80" data-mp="23eftim8bnyhs">
          {clinic.thankYouBody}
        </p>

        <div className="mx-auto mt-12 flex max-w-md items-center gap-4 border-y border-cream-100/15 px-2 py-5 text-left" data-id="element-81" data-mp="noby13joxzvy">
          <MessageCircleIcon className="h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-82" data-mp="iqa7xynul0az" />
          <p className="font-sans text-sm leading-relaxed text-cream-100/70" data-id="element-83" data-mp="xeogmq7y3izg">{clinic.contact}</p>
        </div>

        <div className="mt-14 flex flex-col items-center" data-id="element-84" data-mp="smn7ve9zkae6">
          <BrandMark className="items-center" data-id="element-85" data-mp="16f32prsqh240" />
          <p className="mt-4 font-sans text-[11px] uppercase tracking-[0.2em] text-cream-100/45" data-id="element-86" data-mp="16drzpu743ydy">
            {clinic.specialistName} · {clinic.location}
          </p>
        </div>

        <button type="button" onClick={onRestart} className="mx-auto mt-8 inline-flex items-center gap-2 font-sans text-xs uppercase tracking-[0.2em] text-cream-100/55 transition-colors duration-200 ease-soft hover:text-cream-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" data-id="element-87" data-mp="1gdiy46ysmxjb">
          <RotateCcwIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-88" data-mp="3d7dngms8nrye" />
          Preencher novamente
        </button>
      </div>
    </section>;
}